(function () {
  const TAG = '[cart-outlet-sync]';
  const OUTLET_KEY = 'Outlet';

  /** Runs as soon as the file loads — if you never see this, the asset is not on the storefront theme or failed to load (check Network). */
  console.log(TAG, 'script loaded', { pathname: window.location.pathname, href: window.location.href });

  function logVerbose(msg, data, reason) {
    if (reason === 'cart-update') console.debug(TAG, msg, data);
    else console.log(TAG, msg, data);
  }

  function isCartPagePath() {
    const p = window.location.pathname || '';
    return p === '/cart' || /\/cart\/?$/.test(p);
  }

  function hasOutletLineInDom() {
    return !!document.querySelector('#main-cart-items tr.cart-item[data-outlet-line="true"]');
  }

  async function clearOutletCartAttributeIfNeeded(reason) {
    if (!isCartPagePath()) {
      logVerbose('skip: not cart page', { reason, path: window.location.pathname }, reason);
      return;
    }

    if (hasOutletLineInDom()) {
      logVerbose('skip: cart has outlet line item(s) in DOM', { reason }, reason);
      return;
    }

    let cart;
    try {
      const r = await fetch('/cart.js');
      if (!r.ok) {
        console.warn(TAG, 'cart.js request failed', r.status, { reason });
        return;
      }
      cart = await r.json();
    } catch (err) {
      console.warn(TAG, 'cart.js fetch error', err, { reason });
      return;
    }

    const attrs = cart.attributes || {};
    if (!attrs[OUTLET_KEY]) {
      logVerbose('skip: no Outlet cart attribute', { reason, attributes: attrs }, reason);
      return;
    }

    console.log(TAG, 'clearing Outlet attribute', {
      reason,
      previousValue: attrs[OUTLET_KEY],
      item_count: cart.item_count,
    });

    try {
      if (typeof fetchConfig !== 'function' || !window.routes || !window.routes.cart_update_url) {
        console.error(TAG, 'missing fetchConfig or window.routes.cart_update_url', {
          fetchConfig: typeof fetchConfig,
          routes: window.routes,
        });
        return;
      }
      const res = await fetch(window.routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: { [OUTLET_KEY]: '' } }),
      });
      if (!res.ok) {
        console.error(TAG, 'cart/update.js failed', res.status, await res.text().catch(() => ''));
        return;
      }
      console.log(TAG, 'Outlet attribute cleared', { reason, status: res.status });
    } catch (e) {
      console.error(TAG, 'cart/update.js error', e);
    }
  }

  function init() {
    if (!isCartPagePath()) {
      console.log(
        TAG,
        'init skipped — URL does not look like cart page (expected path /cart or …/xx/cart)',
        { pathname: window.location.pathname }
      );
      return;
    }

    console.log(TAG, 'init', { path: window.location.pathname });

    clearOutletCartAttributeIfNeeded('domready');

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (!isCartPagePath()) return;
        requestAnimationFrame(function () {
          clearOutletCartAttributeIfNeeded('cart-update');
        });
      });
      console.log(TAG, 'subscribed to', PUB_SUB_EVENTS.cartUpdate);
    } else {
      console.warn(TAG, 'subscribe / PUB_SUB_EVENTS not available (cart qty sync logs only on checkout)');
    }

    const form = document.getElementById('cart');
    if (!form) {
      console.warn(TAG, 'form#cart not found — checkout intercept not attached');
      return;
    }

    let checkoutBypass = false;
    form.addEventListener(
      'submit',
      async function (e) {
        if (checkoutBypass) {
          checkoutBypass = false;
          console.debug(TAG, 'checkout submit: bypass (resume after sync)');
          return;
        }
        const sub = e.submitter;
        if (!sub || sub.getAttribute('name') !== 'checkout') {
          console.debug(TAG, 'submit ignored (not checkout)', sub && sub.getAttribute('name'));
          return;
        }

        console.log(TAG, 'checkout submit intercepted → sync then continue');
        e.preventDefault();
        e.stopPropagation();

        await clearOutletCartAttributeIfNeeded('checkout');

        checkoutBypass = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(sub);
        } else {
          form.submit();
        }
      },
      true
    );
    console.log(TAG, 'checkout submit listener attached on #cart');
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (e) {
    console.error(TAG, 'fatal error during setup', e);
  }
})();
